import { render, staticRenderFns } from "./orderConfirmation.vue?vue&type=template&id=27b05ced&scoped=true&"
import script from "./orderConfirmation.vue?vue&type=script&lang=js&"
export * from "./orderConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./orderConfirmation.vue?vue&type=style&index=0&id=27b05ced&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b05ced",
  null
  
)

export default component.exports